import { applyMiddleware, combineReducers, createStore } from 'redux';
import createSagaMiddleware from 'redux-saga';

import reducers from './reducers';
import reducersUi from './reducers_ui';
import rootSaga from './saga';

const rootReducer = combineReducers({
  ...reducers,
  ...reducersUi,
});

const bindMiddleware = (middleware) => {
  if (process.env.NODE_ENV !== 'production') {
    const { composeWithDevTools } = require('@redux-devtools/extension');
    // return composeWithDevTools({ trace: true })(applyMiddleware(...middleware));
    return composeWithDevTools(applyMiddleware(...middleware));
  }
  return applyMiddleware(...middleware);
};

export const makeStore = () => {
  const sagaMiddleware = createSagaMiddleware();
  const store = createStore(rootReducer, bindMiddleware([sagaMiddleware]));

  store.sagaTask = sagaMiddleware.run(rootSaga);

  return store;
};

// export const wrapper = createWrapper(makeStore, { debug: process.env.NODE_ENV !== 'production' });
